var map = {
	"./angular.png": "8fd8",
	"./bootstrap.png": "60e8",
	"./csharp.png": "3db2",
	"./css.png": "3cee",
	"./database.png": "82d5",
	"./html.png": "26f5",
	"./java.png": "54ee",
	"./jquery.png": "dfb6",
	"./js.png": "3db2d",
	"./mongo.png": "bbd5",
	"./mysql.png": "272b",
	"./postgre.png": "df21",
	"./python.png": "8832",
	"./react.png": "b8a7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79a0";